const SwitchGroupValidator = (required, message) => {
    return (val) => {
        const msg = (message ?? `Please select more options.`);

        if (!val) {
            return [false, msg];
        }

        const valid = required.reduce((v, r) => v && (val[r] ?? false), true);

        return [
            valid,
            valid ? null : msg,
        ]
    }
}

export default SwitchGroupValidator;
